import type { CVHighlight } from '../../../lib/cv-mock-data';

function signature(item: CVHighlight) {
  return `${item.title.trim().toLocaleLowerCase()}\u0000${item.desc.trim().toLocaleLowerCase()}`;
}

export function pickHighlightSuggestion(
  generated: readonly CVHighlight[],
  existing: readonly CVHighlight[],
) {
  const existingSignatures = new Set(existing.map(signature));
  return generated.find((item) => !existingSignatures.has(signature(item))) ?? null;
}

export function highlightListsMatch(
  left: readonly CVHighlight[],
  right: readonly CVHighlight[],
) {
  if (left.length !== right.length) return false;
  return left.every((item, index) => {
    const other = right[index];
    return Boolean(other) && item.id === other.id && item.title === other.title && item.desc === other.desc;
  });
}
